import { createFileRoute } from '@tanstack/react-router'
import { guardStudentOnly } from '@/lib/auth/routeGuards'
import StudentService from '@/components/studentPage/StudentService'

export const Route = createFileRoute('/student/')({
  beforeLoad: guardStudentOnly,
  component: index,
})

function index() {
  return <StudentService />
}
